"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9201],{

/***/ 2409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);





var BookmarkIcon = function(_param) /*#__PURE__*/ {
    var _fill = _param.fill, fill = _fill === void 0 ? "#FFF" : _fill, _stroke = _param.stroke, stroke = _stroke === void 0 ? "#A5ADBA" : _stroke, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "fill",
        "stroke"
    ]);
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 12 18",
        width: 12,
        height: 18
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
            d: "M11.47 17.205l-5.345-5.452a.175.175 0 00-.25 0L.53 17.205V.54h10.942v16.665z",
            fillRule: "nonzero",
            fill: fill,
            stroke: stroke
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BookmarkIcon);


/***/ }),

/***/ 83378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BackToTop; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81031);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67459);







function BackToTop() {
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showScroll = ref[0], setShowScroll = ref[1];
    var checkScrollTop = function() {
        if (!showScroll && window.pageYOffset > 400) {
            setShowScroll(true);
        } else if (showScroll && window.pageYOffset <= 400) {
            setShowScroll(false);
        }
    };
    var scrollTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("scroll", checkScrollTop);
        return function() {
            window.removeEventListener("scroll", checkScrollTop);
        };
    }, [
        showScroll
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
        "aria-hidden": showScroll === false,
        style: {
            display: showScroll ? "flex" : "none"
        },
        css: {
            position: "fixed",
            right: 24,
            bottom:  true ? 160 : 0,
            zIndex: 9999,
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("button", {
            type: "button",
            onClick: scrollTop,
            tabIndex: -1,
            "aria-label": "Back to top",
            css: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                margin: 0,
                padding: 0,
                color: _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .palette.white */ .DG.white,
                backgroundColor: "rgba(0, 0, 0, 0.2)",
                border: "none",
                borderRadius: "100%",
                outline: "none",
                cursor: "pointer",
                appearance: "none",
                userSelect: "none",
                "&:hover": {
                    backgroundColor: _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .palette.blue[500] */ .DG.blue[500],
                    boxShadow: "0 1px 8px 0 #33333366",
                    transition: "box-shadow 60ms ease 0s",
                    animation: "".concat(wiggle, " 1.2s ease"),
                    animationIterationCount: 1
                },
                WebkitAppearance: "none"
            },
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ArrowUp, {
                width: 32,
                height: 32,
                display: "flex"
            })
        })
    });
};
var ArrowUp = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: 32,
        height: 32,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
            d: "M12 19V5M5 12l7-7 7 7"
        })
    }));
};
var wiggle = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .keyframes */ .F4)("20%{transform:translateY(6px);}40%{transform:translateY(-6px);}60%{transform:translateY(4px);}80%{transform:translateY(-2px);}100%{transform:translateY(0);}");


/***/ }),

/***/ 81177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mutations_ToggleFollow; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./lib/mutations/getTargetType.ts
var getTargetType = __webpack_require__(42293);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./lib/mutations/ToggleFollowMutation.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ToggleFollow($targetType: FollowType!, $targetId: ObjectId!) {\n    toggleFollow(targetType: $targetType, targetId: $targetId) {\n      __typename\n      ... on Government {\n        _id\n        isFollowing\n      }\n      ... on VendorUser {\n        _id\n        isFollowing\n      }\n      ... on GovernmentUser {\n        _id\n        isFollowing\n      }\n      ... on PendingUser {\n        _id\n        isFollowing\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var ToggleFollowMutation = ((0,lib/* gql */.Ps)(_templateObject()));

// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./lib/apollo/RefetchQueriesFixLink.ts
var RefetchQueriesFixLink = __webpack_require__(69086);
;// CONCATENATED MODULE: ./lib/mutations/ToggleFollow.tsx







var ToggleFollow = function(param) {
    var entityType = param.entityType, targetId = param.targetId, viewerIsFollowing = param.viewerIsFollowing, children = param.children;
    var user = (0,Auth/* useSelfie */.yD)();
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: ToggleFollowMutation,
        variables: {
            targetType: (0,getTargetType/* default */.Z)(entityType),
            targetId: targetId
        },
        refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
            "GetProfile"
        ]),
        children: function(toggleFollow) {
            return children({
                toggle: function() {
                    toggleFollow({
                        optimisticResponse: {
                            __typename: "Mutation",
                            toggleFollow: {
                                __typename: entityType,
                                _id: targetId,
                                isFollowing: !viewerIsFollowing
                            }
                        }
                    });
                }
            });
        }
    });
};
/* harmony default export */ var mutations_ToggleFollow = (ToggleFollow);


/***/ }),

/***/ 42293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTargetType; }
/* harmony export */ });
function getTargetType(entityType) {
    if ([
        "VendorUser",
        "GovernmentUser",
        "PendingUser"
    ].includes(entityType)) {
        return "USER";
    } else if (entityType === "Company") {
        return "COMPANY";
    } else if (entityType === "Government") {
        return "GOVERNMENT";
    } else {
        // should never happen... but ¯\_(ツ)_/¯
        throw new Error("Invalid entityType provided");
    }
};


/***/ }),

/***/ 59201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LandingPage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./components/qol/BackToTop.tsx
var BackToTop = __webpack_require__(83378);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./src/utils/stringOrFirst.ts
var stringOrFirst = __webpack_require__(39327);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/landingPage/HeaderBanner.tsx




function HeaderBanner(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
        position: "relative",
        pt: "30px",
        pb: "30px",
        children: [
            data.backgroundImage && data.backgroundImage.url && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                ignoreFallback: true,
                alt: data.backgroundImage.alt || "",
                src: data.backgroundImage.url,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                position: "absolute",
                left: 0,
                top: 0
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageGridContainer */.pf, {
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                    position: "relative",
                    textAlign: [
                        "center",
                        "center",
                        "center",
                        "left"
                    ],
                    minHeight: "350px",
                    display: "flex",
                    flexDirection: [
                        "column",
                        "column",
                        "column",
                        "row"
                    ],
                    alignItems: [
                        "center",
                        "center",
                        "center",
                        "center"
                    ],
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                            position: "relative",
                            zIndex: 99,
                            maxWidth: [
                                "100%",
                                "100%",
                                "100%",
                                "50%"
                            ],
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Heading */.E2, {
                                    as: "h1",
                                    fontSize: [
                                        "32px",
                                        "32px",
                                        "55px"
                                    ],
                                    color: data.titleColor || "#ffffff",
                                    maxWidth: [
                                        "auto",
                                        "auto",
                                        "auto",
                                        "770px"
                                    ],
                                    lineHeight: [
                                        "38px",
                                        "38px",
                                        "60px"
                                    ],
                                    children: [
                                        data.title,
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("sup", {
                                            css: {
                                                margin: 0,
                                                padding: 0,
                                                fontSize: 32,
                                                "@media (max-width: 768px)": {
                                                    top: "-0.25em"
                                                }
                                            },
                                            children: "\xae"
                                        })
                                    ]
                                }),
                                data.subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                                    mt: [
                                        "24px",
                                        "24px",
                                        "24px",
                                        "8px"
                                    ],
                                    as: "h2",
                                    fontWeight: [
                                        "bold",
                                        "bold",
                                        "normal"
                                    ],
                                    fontSize: [
                                        "18px",
                                        "18px",
                                        "28px"
                                    ],
                                    color: data.subtitleColor || "#ffffff",
                                    maxWidth: [
                                        "auto",
                                        "auto",
                                        "auto",
                                        "610px"
                                    ],
                                    children: data.subtitle
                                }),
                                (data.leftButtonText || data.rightButtonText) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                                    display: "flex",
                                    wrap: "nowrap",
                                    direction: [
                                        "column",
                                        "column",
                                        "row",
                                        "row"
                                    ],
                                    align: [
                                        "center",
                                        "center",
                                        "center",
                                        "unset"
                                    ],
                                    mt: [
                                        "40px",
                                        "40px",
                                        "40px",
                                        "40px"
                                    ],
                                    order: [
                                        2,
                                        2,
                                        2,
                                        1
                                    ],
                                    children: [
                                        data.leftButtonText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderBannerButton, {
                                            text: data.leftButtonText,
                                            href: data.leftButtonHref,
                                            backgroundColor: data.leftButtonBackgroundColor,
                                            textColor: data.leftButtonTextColor,
                                            borderColor: data.leftButtonBorderColor,
                                            hoverColor: data.leftButtonHoverColor,
                                            mr: data.rightButtonText ? [
                                                "0px",
                                                "0px",
                                                "24px",
                                                "24px"
                                            ] : 0
                                        }),
                                        data.rightButtonText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderBannerButton, {
                                            mt: [
                                                "12px",
                                                "12px",
                                                "0px",
                                                "0px"
                                            ],
                                            text: data.rightButtonText,
                                            href: data.rightButtonHref,
                                            backgroundColor: data.rightButtonBackgroundColor,
                                            textColor: data.rightButtonTextColor,
                                            borderColor: data.rightButtonBorderColor,
                                            hoverColor: data.rightButtonHoverColor
                                        })
                                    ]
                                })
                            ]
                        }),
                        data.foregroundImage && data.foregroundImage.url && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                            ignoreFallback: true,
                            zIndex: 1,
                            mt: [
                                "32px",
                                "32px",
                                "32px",
                                0
                            ],
                            ml: [
                                0,
                                0,
                                0,
                                "auto"
                            ],
                            mx: [
                                "auto",
                                "auto",
                                "auto",
                                null
                            ],
                            width: [
                                "100%",
                                "100%",
                                "550px",
                                "550px"
                            ],
                            height: [
                                200,
                                300,
                                "368px",
                                "368px"
                            ],
                            src: data.foregroundImage.url,
                            alt: data.foregroundImage.alt || "",
                            position: [
                                "relative",
                                "relative",
                                "relative"
                            ],
                            objectFit: "contain"
                        })
                    ]
                })
            })
        ]
    });
};
function HeaderBannerButton(param) {
    var text = param.text, href = param.href, backgroundColor = param.backgroundColor, textColor = param.textColor, borderColor = param.borderColor, hoverColor = param.hoverColor, mr = param.mr, mt = param.mt;
    if (href && !href.startsWith("http")) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                variant: "primary",
                bg: backgroundColor,
                color: textColor || "#ffffff",
                borderColor: borderColor,
                _hover: {
                    bg: hoverColor,
                    borderColor: hoverColor
                },
                rel: "noreferrer noopener",
                minWidth: "250px",
                whiteSpace: "pre-wrap",
                textAlign: "center",
                mr: mr,
                mt: mt,
                children: text
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
        variant: "primary",
        href: href || "",
        bg: backgroundColor,
        color: textColor || "#ffffff",
        borderColor: borderColor,
        _hover: {
            bg: hoverColor,
            borderColor: hoverColor
        },
        external: "outside-redirect",
        rel: "noreferrer noopener",
        minWidth: "250px",
        whiteSpace: "pre-wrap",
        textAlign: "center",
        mr: mr,
        mt: mt,
        onClick: function(event) {
            if (!href) {
                event.preventDefault();
            }
        },
        children: text
    });
}

;// CONCATENATED MODULE: ./src/components/landingPage/headerBannerExists.ts
function headerBannerExists(headerBannerData) {
    var ref, ref1;
    if (!headerBannerData) {
        return false;
    }
    if (headerBannerData.title || headerBannerData.subtitle || ((ref = headerBannerData.backgroundImage) === null || ref === void 0 ? void 0 : ref.url) || ((ref1 = headerBannerData.foregroundImage) === null || ref1 === void 0 ? void 0 : ref1.url)) {
        return true;
    }
    return false;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49980);
// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-grid-layout@1.3.4_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-grid-layout/index.js
var react_grid_layout = __webpack_require__(74751);
;// CONCATENATED MODULE: ./src/components/landingPage/BlockLayoutContainer.tsx



function BlockLayoutContainer(param) {
    var blockData = param.blockData, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
        px: "20px",
        width: "100%",
        height: "100%",
        flexDirection: "column",
        alignItems: "center",
        overflow: "auto",
        backgroundColor: blockData.backgroundColor || undefined,
        paddingTop: "".concat(blockData.paddingTop || 0, "px"),
        paddingBottom: "".concat(blockData.paddingBottom || 0, "px"),
        paddingRight: "".concat(blockData.paddingRight || 0, "px"),
        paddingLeft: "".concat(blockData.paddingLeft || 0, "px"),
        borderRadius: "5px",
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/landingPage/BlockLayoutContainerTitle.tsx



function BlockLayoutContainerTitle(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        width: "100%",
        mb: "20px",
        fontWeight: 600,
        fontSize: "24px",
        lineHeight: "32px",
        color: "#000000",
        tabIndex: 0,
        children: title
    });
};

;// CONCATENATED MODULE: ./src/components/landingPage/blocks/AdvertisementBlock.tsx



function AdvertisementBlock(param) {
    var blockData = param.blockData;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
        height: "100%",
        width: "100%",
        href: blockData.href,
        external: "outside-redirect",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
            height: "100%",
            width: "100%",
            objectFit: "cover",
            src: blockData.url,
            alt: blockData.alt
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./src/components/landingPage/graphql/TopCollections.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TopCollections($limit: Int = 10) {\n    topCollections(limit: $limit) {\n      _id\n      slug\n      name\n      contentCounters {\n        productsCount\n        projectsCount\n        storiesCount\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var TopCollections = ((0,lib/* default */.ZP)(_templateObject()));

;// CONCATENATED MODULE: ./src/components/landingPage/graphql/TrendingCollections.ts

function TrendingCollections_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TrendingCollections($limit: Int = 10) {\n    trendingCollections(limit: $limit) {\n      _id\n      slug\n      name\n      contentCounters {\n        productsCount\n        projectsCount\n        storiesCount\n      }\n    }\n  }\n"
    ]);
    TrendingCollections_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var TrendingCollections = ((0,lib/* default */.ZP)(TrendingCollections_templateObject()));

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
;// CONCATENATED MODULE: ./src/components/landingPage/icons/CollectionIcon.tsx





function CollectionIcon(_param) {
    var fillColor = _param.fillColor, props = (0,_object_without_properties/* default */.Z)(_param, [
        "fillColor"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.30769 2C3.67521 2 3.07368 2.2244 2.64904 2.64904C2.2244 3.07368 2 3.67521 2 4.30769V7.38462V10.4615V19.6923C2 20.3248 2.2244 20.9263 2.64904 21.351C3.07368 21.7756 3.67521 22 4.30769 22H7H19.6923H20C21.1046 22 22 21.1046 22 20V19.6923V11.2308V10.4615V10V8.92308V7.38462C22 6.75214 21.7756 6.1506 21.351 5.72596C20.9263 5.30132 20.3248 5.07692 19.6923 5.07692H11.2308V4.30769C11.2308 3.67521 11.0064 3.07368 10.5817 2.64904C10.1571 2.2244 9.55556 2 8.92308 2H4.30769ZM20 8C20.1589 8 20.3134 8.01852 20.4615 8.05352V7.38462C20.4615 7.09402 20.377 6.92752 20.2632 6.8137C20.1494 6.69988 19.9829 6.61538 19.6923 6.61538H11.2308C10.8291 6.61538 10.418 6.46971 10.128 6.17969C9.83798 5.88966 9.69231 5.47863 9.69231 5.07692V4.30769C9.69231 4.01709 9.60781 3.8506 9.49399 3.73678C9.38017 3.62296 9.21368 3.53846 8.92308 3.53846H4.30769C4.01709 3.53846 3.8506 3.62296 3.73678 3.73678C3.62296 3.8506 3.53846 4.01709 3.53846 4.30769V7.38462V10.4615V19.6923C3.53846 19.9829 3.62296 20.1494 3.73678 20.2632C3.8506 20.377 4.01709 20.4615 4.30769 20.4615C4.59829 20.4615 4.76478 20.377 4.87861 20.2632C4.92616 20.2157 4.9686 20.1589 5.00189 20.0878C5.00064 20.0587 5 20.0294 5 20V10C5 8.89543 5.89543 8 7 8H20ZM14.9548 13.4977L13.5 11L12.0452 13.4977L9.22025 14.1094L11.1461 16.2648L10.855 19.1406L13.5 17.975L16.145 19.1406L15.8539 16.2648L17.7798 14.1094L14.9548 13.4977Z",
            fill: fillColor || "#086BE5"
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/landingPage/blocks/CenteredLoadingSpinner.tsx



function CenteredLoadingSpinner() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
        width: "100%",
        height: "100%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
    });
};

;// CONCATENATED MODULE: ./src/components/landingPage/blocks/CollectionsBlock.tsx









var CollectionsTab;
(function(CollectionsTab) {
    CollectionsTab["TRENDING"] = "TRENDING";
    CollectionsTab["TOP"] = "TOP";
})(CollectionsTab || (CollectionsTab = {}));
function CollectionsBlock(param) {
    var blockData = param.blockData;
    var ref = (0,react.useState)(CollectionsTab.TRENDING), tab = ref[0], setTab = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
                width: "100%",
                columns: 2,
                fontSize: "24px",
                fontWeight: 600,
                lineHeight: "32px",
                alignItems: "end",
                justifyItems: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        width: "100%",
                        cursor: "pointer",
                        onClick: function() {
                            return setTab(CollectionsTab.TRENDING);
                        },
                        onKeyPress: function(e) {
                            if (e.key === "Enter" || e.key === " ") {
                                setTab(CollectionsTab.TRENDING);
                                e.preventDefault();
                            }
                        },
                        pb: tab === CollectionsTab.TRENDING ? "5px" : "6px",
                        borderBottom: tab === CollectionsTab.TRENDING ? "2px solid ".concat(web/* palette.primary */.DG.primary) : "1px solid #ADB6C3",
                        textAlign: "center",
                        fontSize: [
                            "18px",
                            "24px",
                            "24px",
                            "24px"
                        ],
                        tabIndex: 0,
                        children: blockData.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        width: "100%",
                        cursor: "pointer",
                        onClick: function() {
                            return setTab(CollectionsTab.TOP);
                        },
                        onKeyPress: function(e) {
                            if (e.key === "Enter" || e.key === " ") {
                                setTab(CollectionsTab.TOP);
                                e.preventDefault();
                            }
                        },
                        pb: tab === CollectionsTab.TOP ? "5px" : "6px",
                        borderBottom: tab === CollectionsTab.TOP ? "2px solid ".concat(web/* palette.primary */.DG.primary) : "1px solid #ADB6C3",
                        textAlign: "center",
                        fontSize: [
                            "18px",
                            "24px",
                            "24px",
                            "24px"
                        ],
                        tabIndex: 0,
                        children: blockData.secondTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                mt: "40px",
                width: "100%",
                px: "12px",
                children: [
                    tab === CollectionsTab.TRENDING && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrendingCollectionsTab, {
                        blockData: blockData
                    }),
                    tab === CollectionsTab.TOP && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopCollectionsTab, {
                        blockData: blockData
                    })
                ]
            })
        ]
    });
};
function TrendingCollectionsTab(param) {
    var blockData = param.blockData;
    var ref = (0,useQuery/* useQuery */.a)(TrendingCollections, {
        variables: {
            limit: blockData.itemLimit || 10
        },
        fetchPolicy: "network-only"
    }), data = ref.data, loading = ref.loading;
    if (loading || !data) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CenteredLoadingSpinner, {});
    }
    var collections = data && data.trendingCollections ? data.trendingCollections || [] : [];
    if (blockData.displayAsTags) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsAsTags, {
            collections: collections
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsAsRows, {
        collections: collections
    });
}
function TopCollectionsTab(param) {
    var blockData = param.blockData;
    var ref = (0,useQuery/* useQuery */.a)(TopCollections, {
        variables: {
            limit: blockData.itemLimit || 10
        },
        fetchPolicy: "network-only"
    }), data = ref.data, loading = ref.loading;
    if (loading || !data) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CenteredLoadingSpinner, {});
    }
    var collections = data && data.topCollections ? data.topCollections || [] : [];
    if (blockData.displayAsTags) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsAsTags, {
            collections: collections
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsAsRows, {
        collections: collections
    });
}
function CollectionsAsTags(param) {
    var collections = param.collections;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
        flexDirection: "row",
        flexWrap: "wrap",
        children: collections.map(function(collection) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionTag, {
                    collection: collection
                })
            }, collection._id);
        })
    });
}
function CollectionTag(param) {
    var collection = param.collection;
    var itemCount = collection.contentCounters.productsCount + collection.contentCounters.projectsCount + collection.contentCounters.storiesCount;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/collections/".concat(collection.slug),
        as: "/collections/".concat(collection.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
            tabIndex: 0,
            border: "1px solid #ADB6C3",
            borderRadius: "2px",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "left",
            px: "8px",
            py: "4px",
            mb: "8px",
            mr: "8px",
            cursor: "pointer",
            color: "inherit",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionIcon, {
                    fillColor: "#2f3844",
                    width: "18px",
                    height: "18px"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    ml: "12px",
                    fontWeight: 400,
                    fontSize: "16px",
                    color: "#20252d",
                    children: collection.name
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "gray.300",
                    ml: "16px",
                    children: itemCount > 1 ? "".concat(itemCount, " items") : "".concat(itemCount, " item")
                })
            ]
        })
    });
}
function CollectionsAsRows(param) {
    var collections = param.collections;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
        columns: 1,
        spacing: "20px",
        children: collections.map(function(collection) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionRow, {
                    collection: collection
                })
            }, collection._id);
        })
    });
}
function CollectionRow(param) {
    var collection = param.collection;
    var itemCount = collection.contentCounters.productsCount + collection.contentCounters.projectsCount + collection.contentCounters.storiesCount;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/collections/".concat(collection.slug),
        as: "/collections/".concat(collection.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
            cursor: "pointer",
            tabIndex: 0,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionIcon, {
                    fillColor: "#2f3844",
                    width: "18px",
                    height: "18px"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    width: "300px",
                    ml: "16px",
                    fontWeight: 600,
                    fontSize: "16px",
                    children: collection.name
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    minWidth: "100px",
                    fontWeight: 400,
                    fontSize: "16px",
                    textAlign: "right",
                    children: itemCount > 1 ? "".concat(itemCount, " items") : "".concat(itemCount, " item")
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/moment@2.29.4/node_modules/moment/moment.js
var moment = __webpack_require__(98777);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/components/landingPage/graphql/fragments/LandingPageEventFields.ts

function LandingPageEventFields_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment LandingPageEventFields on LandingPageEvent {\n    _id\n    title\n    url\n    location\n    createdAt\n    startDate\n    endDate\n  }\n"
    ]);
    LandingPageEventFields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var LandingPageEventFields = ((0,lib/* default */.ZP)(LandingPageEventFields_templateObject()));

;// CONCATENATED MODULE: ./src/components/landingPage/graphql/GetUpcomingEvents.ts

function GetUpcomingEvents_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetUpcomingEvents($limit: Int = 20) {\n    getUpcomingEvents(limit: $limit) {\n      ...LandingPageEventFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    GetUpcomingEvents_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var GetUpcomingEvents = ((0,lib/* default */.ZP)(GetUpcomingEvents_templateObject(), LandingPageEventFields));

;// CONCATENATED MODULE: ./src/components/landingPage/blocks/EventsBlock.tsx







function EventsBlock(param) {
    var blockData = param.blockData;
    var ref = (0,useQuery/* useQuery */.a)(GetUpcomingEvents, {
        variables: {
            limit: blockData.itemLimit || 10
        },
        fetchPolicy: "network-only"
    }), data = ref.data, loading = ref.loading;
    if (!data || loading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CenteredLoadingSpinner, {});
    }
    var events = data.getUpcomingEvents && data.getUpcomingEvents.length > 0 ? data.getUpcomingEvents : [];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        width: "100%",
        children: (events || []).map(function(event) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventBlockRow, {
                event: event
            }, event._id);
        })
    });
};
function EventBlockRow(param) {
    var event = param.event;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
        width: "100%",
        direction: [
            "column",
            "column",
            "column",
            "row"
        ],
        alignItems: [
            "left",
            "left",
            "left",
            "center"
        ],
        py: [
            "20px",
            "20px",
            "20px",
            "0px"
        ],
        minHeight: "80px",
        overflow: "hidden",
        borderBottom: "1px solid",
        borderBottomColor: "gray.100",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                width: [
                    "100%",
                    "100%",
                    "100%",
                    "25%"
                ],
                color: "gray.600",
                lineHeight: "24px",
                fontWeight: [
                    400,
                    400,
                    400,
                    600
                ],
                fontSize: "16px",
                children: moment_default()(event.startDate).format("MMM Do, YYYY")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                width: [
                    "100%",
                    "100%",
                    "100%",
                    "50%"
                ],
                href: event.url,
                external: "outside-redirect",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                    lineHeight: [
                        "21.3px",
                        "21.3px",
                        "21.3px",
                        "24px"
                    ],
                    fontWeight: 600,
                    fontSize: "16px",
                    px: [
                        "0px",
                        "0px",
                        "0px",
                        "8px"
                    ],
                    py: [
                        "10px",
                        "10px",
                        "10px",
                        "0px"
                    ],
                    children: event.title
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                width: [
                    "100%",
                    "100%",
                    "100%",
                    "25%"
                ],
                color: "gray.600",
                lineHeight: [
                    "21.3px",
                    "21.3px",
                    "21.3px",
                    "24px"
                ],
                fontWeight: [
                    400,
                    400,
                    400,
                    600
                ],
                fontSize: "16px",
                children: event.location
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/landingPage/graphql/GetExternalLinks.ts

function GetExternalLinks_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetExternalLinks($search: String, $limit: Int = 20, $cursor: Cursor) {\n    externalLinks(search: $search, limit: $limit, cursor: $cursor) {\n      items {\n        _id\n        title\n        url\n        source\n        createdAt\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n        totalCount\n      }\n    }\n  }\n"
    ]);
    GetExternalLinks_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var GetExternalLinks = ((0,lib/* default */.ZP)(GetExternalLinks_templateObject()));

;// CONCATENATED MODULE: ./src/components/landingPage/blocks/ExternalLinksBlock.tsx






function ExternalLinksBlock(param) {
    var blockData = param.blockData;
    var ref;
    var ref1 = (0,useQuery/* useQuery */.a)(GetExternalLinks, {
        variables: {
            search: null,
            limit: blockData.itemLimit || 10,
            cursor: null
        },
        fetchPolicy: "network-only"
    }), data = ref1.data, loading = ref1.loading;
    if (!data || loading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CenteredLoadingSpinner, {});
    }
    var links = (ref = data.externalLinks) === null || ref === void 0 ? void 0 : ref.items;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        width: "100%",
        children: (links || []).map(function(link) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    "&:not(:first-of-type)": {
                        marginTop: "10px"
                    }
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExternalLinkRow, {
                    link: link
                })
            }, "link_".concat(link._id));
        })
    });
};
function ExternalLinkRow(param) {
    var link = param.link;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
        href: link.url,
        external: "outside-redirect",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
            lineHeight: "24px",
            fontSize: "16px",
            fontWeight: [
                400,
                400,
                600,
                600
            ],
            color: web/* palette.primary */.DG.primary,
            children: [
                link.title,
                " ",
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    as: "span",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "gray.900",
                    children: link.source
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/landingPage/graphql/GetStoriesByIds.ts

function GetStoriesByIds_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StoriesByIds($ids: [ObjectId!]!) {\n    storiesByIds(ids: $ids) {\n      _id\n      slug\n      title\n      introduction\n      medias {\n        type\n        url\n        alt\n      }\n      tags {\n        _id\n        name\n        slug\n      }\n    }\n  }\n"
    ]);
    GetStoriesByIds_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var GetStoriesByIds = ((0,lib/* default */.ZP)(GetStoriesByIds_templateObject()));

;// CONCATENATED MODULE: ./src/components/landingPage/blocks/FeaturedStoriesBlock.tsx








function FeaturedStoriesBlock(param) {
    var blockData = param.blockData;
    var ref = (0,useQuery/* useQuery */.a)(GetStoriesByIds, {
        variables: {
            ids: blockData.storyIds
        }
    }), data = ref.data, loading = ref.loading;
    if (!data || loading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CenteredLoadingSpinner, {});
    }
    var stories = data.storiesByIds || [];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
        width: "100%",
        columns: 1,
        spacing: "40px",
        children: stories.map(function(story, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryRow, {
                    story: story,
                    isLast: index === stories.length - 1
                })
            }, story._id);
        })
    });
};
function StoryRow(param) {
    var story = param.story, _isLast = param.isLast, isLast = _isLast === void 0 ? false : _isLast;
    var image = (story.medias || []).find(function(media) {
        var ref;
        return ((ref = media.type) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === types/* IMediaType.Image */.BB.Image;
    });
    var tags = story.tags || [];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/stories/".concat(story.slug),
        as: "/stories/".concat(story.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
            tabIndex: 0,
            width: "100%",
            flexDirection: [
                "column",
                "column",
                "row",
                "row"
            ],
            borderBottom: isLast ? undefined : "1px solid",
            borderColor: isLast ? undefined : "gray.100",
            pb: "40px",
            cursor: "pointer",
            color: "inherit",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                    display: [
                        "block",
                        "block",
                        "none",
                        "none"
                    ],
                    maxWidth: [
                        "100%",
                        "100%",
                        "192px",
                        "192px"
                    ],
                    maxHeight: [
                        "120px",
                        "120px",
                        "160px",
                        "160px"
                    ],
                    objectFit: "cover",
                    src: image ? image.url : "".concat(getGovlaunchBaseUrl(), "/static/story/story-card-placeholder.png"),
                    alt: image ? image.alt || "" : ""
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                    flexDirection: "column",
                    mt: [
                        "12px",
                        "12px",
                        "0px",
                        "0px"
                    ],
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            mr: [
                                "0px",
                                "0px",
                                "12px",
                                "12px"
                            ],
                            fontWeight: [
                                700,
                                700,
                                600,
                                600
                            ],
                            fontSize: [
                                "18px",
                                "18px",
                                "24px",
                                "24px"
                            ],
                            lineHeight: [
                                "24px",
                                "24px",
                                "32px",
                                "32px"
                            ],
                            color: "blue.700",
                            children: story.title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            display: [
                                "none",
                                "none",
                                "block",
                                "block"
                            ],
                            mr: [
                                "0px",
                                "0px",
                                "12px",
                                "12px"
                            ],
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "20px",
                            mt: "6px",
                            children: story.introduction
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                            flexDirection: "row",
                            mt: [
                                "12px",
                                "12px",
                                "30px",
                                "30px"
                            ],
                            alignItems: "center",
                            children: [
                                tags.slice(0, 2).map(function(tag) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            "&:not(:first-of-type)": {
                                                marginLeft: "8px"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryRowTag, {
                                            name: tag.name
                                        })
                                    }, tag._id);
                                }),
                                tags.length > 2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                    fontWeight: 900,
                                    fontSize: "12px",
                                    lineHeight: "19px",
                                    color: "blue.700",
                                    ml: "12px",
                                    py: "4px",
                                    children: [
                                        "+",
                                        tags.length - 2
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                    ml: "auto",
                    display: [
                        "none",
                        "none",
                        "block",
                        "block"
                    ],
                    maxWidth: [
                        "84px",
                        "84px",
                        "192px",
                        "192px"
                    ],
                    maxHeight: [
                        "84px",
                        "84px",
                        "160px",
                        "160px"
                    ],
                    objectFit: "cover",
                    src: image ? image.url : "".concat(getGovlaunchBaseUrl(), "/static/story/story-card-placeholder.png"),
                    alt: image ? image.alt || "" : ""
                })
            ]
        })
    });
}
function StoryRowTag(param) {
    var name = param.name;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "16px",
        color: "gray.700",
        px: "8px",
        py: "4px",
        border: "1px solid",
        borderColor: "gray.300",
        borderRadius: 2,
        textTransform: "uppercase",
        children: name
    });
}
function getGovlaunchBaseUrl() {
    var environment = "production";
    if (environment === "qa") {
        return "https://qa.govlaunch.com";
    } else if (environment === "production") {
        return "https://govlaunch.com";
    }
    return "http://localhost:3000";
}

// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./components/icons/BookmarkIcon.tsx
var BookmarkIcon = __webpack_require__(2409);
// EXTERNAL MODULE: ./lib/mutations/ToggleFollow.tsx + 1 modules
var ToggleFollow = __webpack_require__(81177);
;// CONCATENATED MODULE: ./src/components/landingPage/graphql/TopInnovatorGovernments.ts

function TopInnovatorGovernments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TopInnovatorGovernments($limit: Int = 10) {\n    topInnovatorGovernments(limit: $limit) {\n      _id\n      slug\n      name\n      logo\n      city {\n        _id\n        name\n        state\n        country\n        stateName: state(full: true)\n        type\n        county\n      }\n      isFollowing\n    }\n  }\n"
    ]);
    TopInnovatorGovernments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var TopInnovatorGovernments = ((0,lib/* default */.ZP)(TopInnovatorGovernments_templateObject()));

;// CONCATENATED MODULE: ./src/components/landingPage/graphql/TrendingGovernments.ts

function TrendingGovernments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TrendingGovernments($limit: Int = 10) {\n    trendingGovernments(limit: $limit) {\n      _id\n      slug\n      name\n      logo\n      city {\n        _id\n        name\n        state\n        country\n        stateName: state(full: true)\n        type\n        county\n      }\n      isFollowing\n    }\n  }\n"
    ]);
    TrendingGovernments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var TrendingGovernments = ((0,lib/* default */.ZP)(TrendingGovernments_templateObject()));

;// CONCATENATED MODULE: ./src/components/landingPage/icons/FollowGovernmentIcon.tsx




function FollowGovernmentIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M18 12V20.0636L12.6778 17.3716L12 17.0288L11.3243 17.3708L6 20.061V3H13.5V1.5H6C5.60218 1.5 5.22064 1.65804 4.93934 1.93934C4.65804 2.22064 4.5 2.60218 4.5 3V22.5L12 18.7097L19.5 22.5V12H18Z",
                fill: "#2F3844"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M19.5 4.5V1.5H18V4.5H15V6H18V9H19.5V6H22.5V4.5H19.5Z",
                fill: "#2F3844"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/landingPage/blocks/GovernmentsBlock.tsx












var GovernmentsTab;
(function(GovernmentsTab) {
    GovernmentsTab["TRENDING"] = "TRENDING";
    GovernmentsTab["INNOVATORS"] = "INNOVATORS";
})(GovernmentsTab || (GovernmentsTab = {}));
function GovernmentsBlock(param) {
    var blockData = param.blockData;
    var ref = (0,react.useState)(GovernmentsTab.TRENDING), tab = ref[0], setTab = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
                width: "100%",
                columns: 2,
                fontSize: "24px",
                fontWeight: 600,
                lineHeight: "32px",
                alignItems: "end",
                justifyItems: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        width: "100%",
                        cursor: "pointer",
                        onClick: function() {
                            return setTab(GovernmentsTab.TRENDING);
                        },
                        onKeyPress: function(e) {
                            if (e.key === "Enter" || e.key === " ") {
                                setTab(GovernmentsTab.TRENDING);
                                e.preventDefault();
                            }
                        },
                        pb: tab === GovernmentsTab.TRENDING ? "5px" : "6px",
                        borderBottom: tab === GovernmentsTab.TRENDING ? "2px solid ".concat(web/* palette.primary */.DG.primary) : "1px solid #ADB6C3",
                        textAlign: "center",
                        fontSize: [
                            "18px",
                            "24px",
                            "24px",
                            "24px"
                        ],
                        tabIndex: 0,
                        children: blockData.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        width: "100%",
                        cursor: "pointer",
                        onClick: function() {
                            return setTab(GovernmentsTab.INNOVATORS);
                        },
                        onKeyPress: function(e) {
                            if (e.key === "Enter" || e.key === " ") {
                                setTab(GovernmentsTab.INNOVATORS);
                                e.preventDefault();
                            }
                        },
                        pb: tab === GovernmentsTab.INNOVATORS ? "5px" : "6px",
                        borderBottom: tab === GovernmentsTab.INNOVATORS ? "2px solid ".concat(web/* palette.primary */.DG.primary) : "1px solid #ADB6C3",
                        textAlign: "center",
                        fontSize: [
                            "18px",
                            "24px",
                            "24px",
                            "24px"
                        ],
                        tabIndex: 0,
                        children: blockData.secondTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                mt: "40px",
                width: "100%",
                px: "12px",
                children: [
                    tab === GovernmentsTab.TRENDING && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrendingGovernmentsTab, {
                        blockData: blockData
                    }),
                    tab === GovernmentsTab.INNOVATORS && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InnovatorGovernmentsTab, {
                        blockData: blockData
                    })
                ]
            })
        ]
    });
};
function TrendingGovernmentsTab(param) {
    var blockData = param.blockData;
    var ref = (0,useQuery/* useQuery */.a)(TrendingGovernments, {
        variables: {
            limit: blockData.itemLimit || 10
        },
        fetchPolicy: "network-only"
    }), data = ref.data, loading = ref.loading;
    if (loading || !data) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CenteredLoadingSpinner, {});
    }
    var governments = data && data.trendingGovernments ? data.trendingGovernments || [] : [];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
        width: "100%",
        height: "100%",
        columns: 1,
        alignItems: "center",
        spacing: "20px",
        children: governments.map(function(government) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentRow, {
                    government: government
                })
            }, government._id);
        })
    });
}
function InnovatorGovernmentsTab(param) {
    var blockData = param.blockData;
    var ref = (0,useQuery/* useQuery */.a)(TopInnovatorGovernments, {
        variables: {
            limit: blockData.itemLimit || 10
        },
        fetchPolicy: "network-only"
    }), data = ref.data, loading = ref.loading;
    if (loading || !data) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CenteredLoadingSpinner, {});
    }
    var governments = data && data.topInnovatorGovernments ? data.topInnovatorGovernments || [] : [];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
        width: "100%",
        height: "100%",
        columns: 1,
        alignItems: "center",
        spacing: "20px",
        children: governments.map(function(government) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentRow, {
                    government: government
                })
            }, government._id);
        })
    });
}
function GovernmentRow(param) {
    var government = param.government;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
        width: "100%",
        columns: 1,
        cursor: "pointer",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
            flexDirection: "row",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/governments/".concat(government.slug),
                    as: "/governments/".concat(government.slug),
                    passHref: true,
                    tabIndex: 0,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
                        flexDirection: "row",
                        alignItems: "center",
                        color: "inherit",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                size: "sm",
                                name: government.name,
                                src: government.logo
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                                flexDirection: "column",
                                ml: "8px",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                        fontSize: "16px",
                                        fontWeight: 600,
                                        lineHeight: "21px",
                                        children: government.name
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                                        flexDirection: "row",
                                        mt: "4px",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                                width: 20,
                                                height: 12,
                                                countryCode: government.city.country
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                fontSize: "12px",
                                                fontWeight: 400,
                                                lineHeight: "16px",
                                                color: "blue.600",
                                                ml: "4px",
                                                children: getCountryFriendlyName(government.city.country)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    ml: "auto",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentRowFollowButton, {
                        government: government
                    })
                })
            ]
        })
    });
}
function GovernmentRowFollowButton(param) {
    var government = param.government;
    var user = (0,Auth/* useSelfie */.yD)();
    if (!user) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: "/signup",
            passHref: true,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FollowGovernmentIcon, {
                    cursor: "pointer"
                })
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleFollow/* default */.Z, {
        targetId: government._id,
        entityType: "Government",
        viewerIsFollowing: government.isFollowing,
        children: function(param) {
            var toggle = param.toggle;
            if (!government.isFollowing) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FollowGovernmentIcon, {
                    onClick: toggle,
                    cursor: "pointer"
                });
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookmarkIcon/* default */.Z, {
                height: "24px",
                width: "24px",
                fill: web/* palette.primary */.DG.primary,
                onClick: toggle,
                cursor: "pointer"
            });
        }
    });
}
function getCountryFriendlyName(country) {
    switch(country){
        case "US":
            return "United States";
        case "CA":
            return "Canada";
        case "NZ":
            return "New Zealand";
        case "AU":
            return "Australia";
        case "ZA":
            return "South Africa";
        case "GB":
            return "Great Britain";
        case "IE":
            return "Ireland";
        case "FI":
            return "Finland";
        case "SE":
            return "Sweden";
        case "BR":
            return "Brazil";
        case "MX":
            return "Mexico";
        case "AR":
            return "Argentina";
        case "DE":
            return "Germany";
        case "DK":
            return "Denmark";
        case "IT":
            return "Italy";
        case "NL":
            return "Netherlands";
        case "AT":
            return "Austria";
        case "BE":
            return "Belgium";
        case "LI":
            return "Lithuania";
        case "ES":
            return "Spain";
        case "FR":
            return "France";
        case "CH":
            return "Switzerland";
    }
}

;// CONCATENATED MODULE: ./src/components/landingPage/blocks/ImageBlock.tsx



function ImageBlock(param) {
    var blockData = param.blockData;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
        height: "100%",
        width: "100%",
        objectFit: "cover",
        src: blockData.url,
        alt: blockData.alt
    });
};

;// CONCATENATED MODULE: ./src/components/project/graphql/GetNewProjects.ts

function GetNewProjects_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetNewProject($cursor: Cursor, $limit: Int = 30) {\n    getNewProjects(limit: $limit, cursor: $cursor) {\n      items {\n        _id\n        slug\n        ... on VendorProject {\n          title\n          countryCode\n        }\n        ... on GovernmentProject {\n          title\n          countryCode\n        }\n        ... on GroupProject {\n          title\n          countryCode\n        }\n      }\n      pageInfo {\n        totalCount\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n"
    ]);
    GetNewProjects_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var GetNewProjects = ((0,lib/* default */.ZP)(GetNewProjects_templateObject()));

;// CONCATENATED MODULE: ./src/components/landingPage/blocks/NewProjectsBlock.tsx







function NewProjectsBlock(param) {
    var blockData = param.blockData;
    var ref;
    var ref1 = (0,useQuery/* useQuery */.a)(GetNewProjects, {
        variables: {
            cursor: null,
            limit: blockData.itemLimit || 10
        },
        fetchPolicy: "network-only"
    }), data = ref1.data, loading = ref1.loading;
    if (!data || loading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CenteredLoadingSpinner, {});
    }
    var projects = ((ref = data.getNewProjects) === null || ref === void 0 ? void 0 : ref.items) || [];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        width: "100%",
        height: "100%",
        children: projects.map(function(project) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    "&:not(:first-of-type)": {
                        marginTop: "20px"
                    }
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectRow, {
                    project: project
                })
            }, project._id);
        })
    });
};
function ProjectRow(param) {
    var project = param.project;
    var country = project.title.match(/([A-zÀ-ú-/&'., 0-9]+, (?:[A-Z]{2,3}))\s(.+)/);
    var title = country ? project.title.replace(country[1], "") : project.title;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/projects/".concat(project.slug),
        as: "/projects/".concat(project.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
            width: "100%",
            flexDirection: "row",
            alignItems: "start",
            cursor: "pointer",
            color: "inherit",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    src: "https://static.govlaunch.com/flags/squared/".concat(project.countryCode || "", ".svg"),
                    width: "30px",
                    alt: project.countryCode || "",
                    title: project.countryCode || "",
                    style: {
                        border: 0,
                        outline: "none",
                        textDecoration: "none",
                        margin: 0,
                        padding: 0,
                        marginTop: "6px",
                        marginRight: "10px"
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                    children: [
                        country && country[1] && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            style: {
                                color: "#086bef",
                                fontWeight: 700,
                                fontSize: "16px",
                                lineHeight: "24px",
                                letterSpacing: "normal"
                            },
                            children: country[1]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                fontWeight: 400,
                                fontSize: 16,
                                lineHeight: "24px"
                            },
                            children: title
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/node-html-parser@6.1.0/node_modules/node-html-parser/dist/index.js
var dist = __webpack_require__(67976);
;// CONCATENATED MODULE: ./src/components/landingPage/blocks/PodcastBlock.tsx




function PodcastBlock(param) {
    var blockData = param.blockData;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        width: "100%",
        height: "100%",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
            src: extractSrc(blockData.podcastSrc),
            frameBorder: "0",
            css: {
                width: "100%",
                height: "100%"
            }
        })
    });
};
function extractSrc(value) {
    var code = (0,dist.parse)(value);
    var iframe = code.querySelector("iframe");
    if (!iframe) {
        return value;
    }
    var iframeSrc = iframe.getAttribute("src");
    if (!iframeSrc || !iframeSrc.includes("player.simplecast.com")) {
        return "";
    }
    return iframeSrc;
}

;// CONCATENATED MODULE: ./src/components/landingPage/graphql/GetGovlaunchStatsCount.ts

function GetGovlaunchStatsCount_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetGovlaunchStatsCount($settings: GovlaunchStatsCountInput!) {\n    govlaunchStatsCount(settings: $settings) {\n      projectsCount\n      productsCount\n      governmentsCount\n      storiesCount\n      vendorsCount\n    }\n  }\n"
    ]);
    GetGovlaunchStatsCount_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var GetGovlaunchStatsCount = ((0,lib/* default */.ZP)(GetGovlaunchStatsCount_templateObject()));

;// CONCATENATED MODULE: ./src/components/landingPage/icons/GovernmentIcon.tsx




function GovernmentIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                width: "32",
                height: "32",
                rx: "4",
                fill: "#2F80ED"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M23.3333 22.3529H22.4167V15.5592H23.3333C23.7284 15.5592 24.0777 15.2923 24.2023 14.8953C24.3279 14.4993 24.1987 14.0626 23.8824 13.8122L16.5491 7.98902C16.2237 7.72892 15.7754 7.72892 15.45 7.98902L8.11667 13.8122C7.80133 14.0626 7.67208 14.4993 7.79767 14.8953C7.92233 15.2923 8.27158 15.5592 8.66667 15.5592H9.58333V22.3529H8.66667C8.15975 22.3529 7.75 22.7867 7.75 23.3234C7.75 23.8601 8.15975 24.2939 8.66667 24.2939H23.3333C23.8403 24.2939 24.25 23.8601 24.25 23.3234C24.25 22.7867 23.8403 22.3529 23.3333 22.3529ZM16 9.97861L20.5833 13.6181H11.4167L16 9.97861ZM11.4167 22.3529V15.5592H13.25V22.3529H11.4167ZM15.0833 22.3529V15.5592H16.9167V22.3529H15.0833ZM18.75 22.3529V15.5592H20.5833V22.3529H18.75Z",
                fill: "white"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/landingPage/icons/ProductIcon.tsx




function ProductIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                width: "32",
                height: "32",
                rx: "4",
                fill: "#2F80ED"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M23.3333 14.1668V23.3335H8.66665V14.1668H23.3333ZM25.1666 12.3335H6.83331V25.1668H25.1666V12.3335Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M23.3334 9.5835H8.66669V11.4168H23.3334V9.5835Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M21.5 6.8335H10.5V8.66683H21.5V6.8335Z",
                fill: "white"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/landingPage/icons/ProjectIcon.tsx




function ProjectIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                width: "32",
                height: "32",
                rx: "4",
                fill: "#2F80ED"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0034 20.2993L13.6167 23.3335H18.3834L19.9967 20.2993C21.0234 19.6399 21.8674 18.7323 22.4506 17.6605C23.0338 16.5886 23.3374 15.3871 23.3334 14.1668C23.3334 12.2219 22.5607 10.3566 21.1855 8.98138C19.8102 7.60611 17.945 6.8335 16 6.8335C14.0551 6.8335 12.1898 7.60611 10.8146 8.98138C9.43931 10.3566 8.6667 12.2219 8.6667 14.1668C8.66268 15.3871 8.9663 16.5886 9.5495 17.6605C10.1327 18.7323 10.9766 19.6399 12.0034 20.2993ZM18.6125 18.9977L17.2834 21.5002H14.7167L13.3875 18.9885L13.1675 18.8602C12.3569 18.3732 11.6856 17.6854 11.2183 16.8633C10.7511 16.0412 10.5037 15.1125 10.5 14.1668C10.5 12.7081 11.0795 11.3092 12.1109 10.2777C13.1424 9.24629 14.5413 8.66683 16 8.66683C17.4587 8.66683 18.8577 9.24629 19.8891 10.2777C20.9206 11.3092 21.5 12.7081 21.5 14.1668C21.498 15.114 21.2513 16.0446 20.784 16.8685C20.3166 17.6923 19.6444 18.3815 18.8325 18.8693L18.6125 18.9977ZM19.6667 13.2502H16.9167V10.5002H15.0833V13.2502H12.3333V15.0835H15.0833V17.8335H16.9167V15.0835H19.6667V13.2502ZM18.75 24.2502H13.25V26.0835H18.75V24.2502Z",
                fill: "white"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/landingPage/icons/StoriesIcon.tsx




function StoriesIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                width: "32",
                height: "32",
                rx: "4",
                fill: "#2F80ED"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M10.1666 10.1665V25.1665H20.1666L25.1666 20.1665V10.1665H10.1666ZM20.1666 22.8082V20.1665H22.8083L20.1666 22.8082ZM23.5 18.4998H18.5V23.4998H11.8333V11.8332H23.5V18.4998Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M15.1667 14.3335H13.5V16.0002H15.1667V14.3335Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M21 14.3335H16.8334V16.0002H21V14.3335Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M16.8333 17.6665H13.5V19.3332H16.8333V17.6665Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M6.83337 6.8335V18.5252V20.1668H8.50004H10.1667V18.5252H8.50004V8.50016H17.6667V10.1668H19.3334V6.8335H6.83337Z",
                fill: "white"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/landingPage/icons/VendorsIcon.tsx




function VendorsIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                width: "32",
                height: "32",
                rx: "4",
                fill: "#2F80ED"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                clipPath: "url(#clip0_15775_99906)",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M16 6.8335C10.9374 6.8335 6.83337 10.9375 6.83337 16.0002C6.83337 21.0628 10.9374 25.1668 16 25.1668C21.0627 25.1668 25.1667 21.0628 25.1667 16.0002C25.1667 10.9375 21.0627 6.8335 16 6.8335ZM16.8367 21.3902V23.1662H15.127V21.5129C13.9266 21.4603 12.8046 21.1448 12.1385 20.7592L12.6601 18.7083C13.3963 19.1115 14.4283 19.4796 15.5676 19.4796C16.5668 19.4796 17.2493 19.0939 17.2493 18.3928C17.2493 17.7267 16.6879 17.306 15.3907 16.8678C13.5152 16.2368 12.2365 15.3604 12.2365 13.6601C12.2365 12.1176 13.3082 10.9082 15.1998 10.5401V8.87053H16.9094V10.4174C18.0735 10.47 18.8755 10.7154 19.4539 10.9958L18.947 12.9765C18.4913 12.7837 17.6857 12.3806 16.4236 12.3806C15.2843 12.3806 14.9165 12.8714 14.9165 13.3622C14.9165 13.9406 15.5302 14.3087 17.0201 14.8696C19.106 15.6058 19.952 16.5698 19.952 18.1474C19.9521 19.7074 18.8373 21.0396 16.8367 21.3902Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                    id: "clip0_15775_99906",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: "22",
                        height: "22",
                        fill: "white",
                        transform: "translate(5 5)"
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/landingPage/blocks/StatCountersBlock.tsx












function StatCountersBlock(param) {
    var blockData = param.blockData;
    var ref = (0,useQuery/* useQuery */.a)(GetGovlaunchStatsCount, {
        variables: {
            settings: {
                countProjects: blockData.showProjects,
                countProducts: blockData.showProducts,
                countGovernments: blockData.showGovernments,
                countStories: blockData.showStories,
                countVendors: blockData.showVendors
            }
        }
    }), data = ref.data, loading = ref.loading;
    if (!data || loading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CenteredLoadingSpinner, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StatCountersContainer, {
        children: [
            blockData.showProjects && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatCountersWidget, {
                count: data.govlaunchStatsCount.projectsCount,
                countColor: blockData.countersColor,
                label: "Projects",
                labelColor: blockData.labelsColor,
                widgetColor: blockData.widgetColor,
                link: "/projects",
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectIcon, {})
            }),
            blockData.showGovernments && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatCountersWidget, {
                count: data.govlaunchStatsCount.governmentsCount,
                countColor: blockData.countersColor,
                label: "Governments",
                labelColor: blockData.labelsColor,
                widgetColor: blockData.widgetColor,
                link: "/governments",
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentIcon, {})
            }),
            blockData.showProducts && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatCountersWidget, {
                count: data.govlaunchStatsCount.productsCount,
                countColor: blockData.countersColor,
                label: "Products",
                labelColor: blockData.labelsColor,
                widgetColor: blockData.widgetColor,
                link: "/products",
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductIcon, {})
            }),
            blockData.showStories && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatCountersWidget, {
                count: data.govlaunchStatsCount.storiesCount,
                countColor: blockData.countersColor,
                label: "Stories",
                labelColor: blockData.labelsColor,
                widgetColor: blockData.widgetColor,
                link: "/stories",
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoriesIcon, {})
            }),
            blockData.showVendors && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatCountersWidget, {
                count: data.govlaunchStatsCount.vendorsCount,
                countColor: blockData.countersColor,
                label: "Vendors",
                labelColor: blockData.labelsColor,
                widgetColor: blockData.widgetColor,
                link: "/vendors",
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorsIcon, {})
            })
        ]
    });
};
function StatCountersContainer(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
        width: "100%",
        height: "100%",
        columns: [
            1,
            1,
            3,
            3
        ],
        spacing: [
            "20px",
            "20px",
            "20px",
            "20px"
        ],
        children: children
    });
}
function StatCountersWidget(param) {
    var count = param.count, countColor = param.countColor, label = param.label, labelColor = param.labelColor, widgetColor = param.widgetColor, link = param.link, icon = param.icon;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: link,
        as: link,
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
            tabIndex: 0,
            width: [
                "100%",
                "100%",
                "100%",
                "100%"
            ],
            height: [
                "100%",
                "100%",
                "150px",
                "150px"
            ],
            background: widgetColor,
            border: "1px solid",
            borderColor: "gray.300",
            borderRadius: "4px",
            position: "relative",
            cursor: "pointer",
            children: [
                icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    position: "absolute",
                    top: [
                        "4px",
                        "4px",
                        "8px"
                    ],
                    left: [
                        "4px",
                        "4px",
                        "8px"
                    ],
                    children: icon
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SvgBox */.$C, {
                    width: "9px",
                    height: "22px",
                    viewBox: "0 0 9 22",
                    fill: "none",
                    position: "absolute",
                    right: 2,
                    top: [
                        "50%",
                        "50%",
                        "42.5%"
                    ],
                    transform: "translateY(-50%)",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M1.88867 19.75L6.77756 11.2244L1.88867 2.25",
                        stroke: "#086BE5",
                        strokeWidth: "3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
                    width: "100%",
                    height: "100%",
                    columns: [
                        2,
                        2,
                        1,
                        1
                    ],
                    alignItems: [
                        "center",
                        "center",
                        "center",
                        "center"
                    ],
                    justifyContent: [
                        "center",
                        "center",
                        "center",
                        "center"
                    ],
                    pl: [
                        "72px",
                        "72px",
                        "0px",
                        "0px"
                    ],
                    py: [
                        "0px",
                        "0px",
                        "40px",
                        "40px"
                    ],
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            fontWeight: 700,
                            fontSize: "32px",
                            lineHeight: "40px",
                            color: countColor,
                            textAlign: [
                                "left",
                                "left",
                                "center",
                                "center"
                            ],
                            children: count
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            fontWeight: 400,
                            fontSize: "16px",
                            lineHeight: "21px",
                            color: labelColor,
                            textAlign: [
                                "left",
                                "left",
                                "center",
                                "center"
                            ],
                            children: label
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/landingPage/BlockLayout.tsx















function BlockLayout(param) {
    var block = param.block;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BlockLayoutContainer, {
        blockData: block.blockData,
        children: [
            isTitleVisible(block.blockData) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlockLayoutContainerTitle, {
                title: block.blockData.title
            }),
            block.blockData.type === types/* IBlockLayoutType.ExternalLinks */.cP.ExternalLinks && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExternalLinksBlock, {
                blockData: block.blockData
            }),
            block.blockData.type === types/* IBlockLayoutType.Podcast */.cP.Podcast && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PodcastBlock, {
                blockData: block.blockData
            }),
            block.blockData.type === types/* IBlockLayoutType.StatCounters */.cP.StatCounters && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatCountersBlock, {
                blockData: block.blockData
            }),
            block.blockData.type === types/* IBlockLayoutType.NewProjects */.cP.NewProjects && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewProjectsBlock, {
                blockData: block.blockData
            }),
            block.blockData.type === types/* IBlockLayoutType.Image */.cP.Image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageBlock, {
                blockData: block.blockData
            }),
            block.blockData.type === types/* IBlockLayoutType.Advertisement */.cP.Advertisement && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementBlock, {
                blockData: block.blockData
            }),
            block.blockData.type === types/* IBlockLayoutType.FeaturedStories */.cP.FeaturedStories && block.blockData.storyIds.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedStoriesBlock, {
                blockData: block.blockData
            }),
            block.blockData.type === types/* IBlockLayoutType.TrendingGovernments */.cP.TrendingGovernments && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentsBlock, {
                blockData: block.blockData
            }),
            block.blockData.type === types/* IBlockLayoutType.TrendingCollections */.cP.TrendingCollections && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsBlock, {
                blockData: block.blockData
            }),
            block.blockData.type === types/* IBlockLayoutType.Events */.cP.Events && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventsBlock, {
                blockData: block.blockData
            })
        ]
    });
}
function isTitleVisible(blockData) {
    if (blockData.type === types/* IBlockLayoutType.TrendingGovernments */.cP.TrendingGovernments || blockData.type === types/* IBlockLayoutType.TrendingCollections */.cP.TrendingCollections) {
        return false;
    }
    return blockData.titleVisible;
}
/* harmony default export */ var landingPage_BlockLayout = (/*#__PURE__*/react.memo(BlockLayout));

;// CONCATENATED MODULE: ./src/components/landingPage/prepareGridData.ts
function prepareGridData(blocks) {
    return blocks.map(function(block) {
        return {
            i: block.i,
            x: block.x,
            y: block.y,
            w: block.w,
            h: block.h,
            isBounded: block.isBounded || true,
            isDraggable: block.isDraggable || false,
            isResizable: block.isResizable || false,
            static: block.static || false,
            blockData: block.blockData
        };
    });
}

// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(32699);
;// CONCATENATED MODULE: ./src/components/landingPage/LandingPageGrid.tsx










var ResponsiveGridLayout = (0,react_grid_layout.WidthProvider)(react_grid_layout.Responsive);
function LandingPageGrid(param) {
    var blocks = param.blocks, allowOverlap = param.allowOverlap;
    var isMobile = (0,useIsMobile/* default */.Z)();
    var ref = (0,react.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    (0,react.useEffect)(function() {
        setIsLoaded(true);
    }, []);
    var lgGridData = prepareGridData(blocks || []);
    var sortByKeys = lgGridData.sort(function(a, b) {
        return a.x - b.x;
    }).sort(function(a, b) {
        if (a.x === b.x) {
            return a.y - b.y;
        }
        return 0;
    }).map(function(item) {
        return item.i;
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
        mt: isMobile ? "40px" : "30px",
        children: [
            !isMobile && isLoaded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResponsiveGridLayout, {
                className: "layout",
                layouts: {
                    lg: lgGridData
                },
                breakpoints: {
                    lg: 1200,
                    md: 960,
                    sm: 640,
                    xs: 480,
                    xxs: 240
                },
                cols: {
                    lg: 16,
                    md: 16,
                    sm: 16,
                    xs: 16,
                    xxs: 16
                },
                rowHeight: 8,
                margin: [
                    8,
                    8
                ],
                isDraggable: false,
                isResizable: false,
                compactType: null,
                allowOverlap: allowOverlap || false,
                children: (0,lodash.sortBy)(blocks || [], function(block) {
                    return sortByKeys.indexOf(block.i);
                }).map(function(block) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landingPage_BlockLayout, {
                            block: block
                        })
                    }, block.i);
                })
            }),
            isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                direction: "column",
                alignItems: "center",
                width: "100%",
                mb: "20px",
                children: (0,lodash.sortBy)(bringStatCountersOnTop(blocks || []), function(block) {
                    return sortByKeys.indexOf(block.i);
                }).map(function(block) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            width: "100%",
                            "&:not(:first-of-type)": {
                                marginTop: "40px"
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landingPage_BlockLayout, {
                            block: block
                        })
                    }, block.i);
                })
            })
        ]
    });
};
function bringStatCountersOnTop(blocks) {
    return (0,_to_consumable_array/* default */.Z)(blocks).sort(function(block1, block2) {
        if (block1.blockData.type !== types/* IBlockLayoutType.StatCounters */.cP.StatCounters && block2.blockData.type === types/* IBlockLayoutType.StatCounters */.cP.StatCounters) {
            return 1;
        }
        if (block1.blockData.type === types/* IBlockLayoutType.StatCounters */.cP.StatCounters && block2.blockData.type !== types/* IBlockLayoutType.StatCounters */.cP.StatCounters) {
            return -1;
        }
        return 0;
    });
}

;// CONCATENATED MODULE: ./src/components/landingPage/graphql/fragments/LandingPageConfigFields.ts

function LandingPageConfigFields_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment LandingPageConfigFields on LandingPageConfig {\n    _id\n    name\n    active\n    createdAt\n    createdBy {\n      ... on PendingUser {\n        _id\n        fullName\n      }\n      ... on VendorUser {\n        _id\n        fullName\n      }\n      ... on GovernmentUser {\n        _id\n        fullName\n      }\n    }\n    deactivatedAt\n    deactivatedBy\n    updatedAt\n    allowOverlap\n    headerBanner {\n      title\n      titleColor\n      subtitle\n      subtitleColor\n      backgroundImage {\n        url\n        alt\n      }\n      foregroundImage {\n        url\n        alt\n      }\n      leftButtonText\n      leftButtonHoverColor\n      leftButtonBorderColor\n      leftButtonBackgroundColor\n      leftButtonTextColor\n      leftButtonHref\n      rightButtonText\n      rightButtonHoverColor\n      rightButtonBorderColor\n      rightButtonBackgroundColor\n      rightButtonTextColor\n      rightButtonHref\n    }\n    blocks {\n      i\n      x\n      y\n      w\n      h\n      static\n      isDraggable\n      isResizable\n      isBounded\n      blockData {\n        type\n        title\n        titleVisible\n        itemLimit\n        backgroundColor\n        paddingTop\n        paddingBottom\n        paddingLeft\n        paddingRight\n        ... on ImageBlockData {\n          url\n          alt\n        }\n        ... on ImageLinkBlockData {\n          url\n          alt\n          href\n        }\n        ... on FeaturedStoriesBlockData {\n          itemLimit\n          storyIds\n        }\n        ... on StatCountersBlockData {\n          labelsColor\n          countersColor\n          widgetColor\n          showProjects\n          showProducts\n          showGovernments\n          showStories\n          showVendors\n        }\n        ... on PodcastBlockData {\n          podcastSrc\n        }\n        ... on GovernmentsBlockData {\n          secondTitle\n        }\n        ... on CollectionsBlockData {\n          secondTitle\n          displayAsTags\n        }\n      }\n    }\n  }\n"
    ]);
    LandingPageConfigFields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var LandingPageConfigFields = ((0,lib/* default */.ZP)(LandingPageConfigFields_templateObject()));

;// CONCATENATED MODULE: ./src/components/landingPage/graphql/GetActiveLandingPageConfig.ts

function GetActiveLandingPageConfig_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetActiveLandingPageConfig($id: ObjectId) {\n    getActiveLandingPageConfig(id: $id) {\n      ...LandingPageConfigFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    GetActiveLandingPageConfig_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var GetActiveLandingPageConfig = ((0,lib/* gql */.Ps)(GetActiveLandingPageConfig_templateObject(), LandingPageConfigFields));

;// CONCATENATED MODULE: ./src/components/landingPage/LandingPageInner.tsx











function LandingPageInner() {
    var router = (0,next_router.useRouter)();
    var previewConfigId = (0,stringOrFirst/* default */.Z)(router.query.configId);
    var ref = (0,useQuery/* useQuery */.a)(GetActiveLandingPageConfig, {
        variables: {
            id: previewConfigId || null
        },
        fetchPolicy: "network-only"
    }), data = ref.data, loading = ref.loading;
    if (!data || loading || !data.getActiveLandingPageConfig) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingPageInnerContent, {
        config: data.getActiveLandingPageConfig
    });
};
function LandingPageInnerContent(param) {
    var config = param.config;
    var user = (0,Auth/* useSelfie */.yD)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            !user && config.headerBanner && headerBannerExists(config.headerBanner) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderBanner, {
                data: config.headerBanner
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingPageGrid, {
                blocks: config.blocks,
                allowOverlap: config.allowOverlap
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/navbar/NavbarLayout.tsx + 62 modules
var NavbarLayout = __webpack_require__(71858);
;// CONCATENATED MODULE: ./pages/landingPage.tsx





function LandingPage() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavbarLayout/* default */.Z, {
        navbarProps: {
            mb: 0
        },
        showBanners: false,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingPageInner, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackToTop/* default */.Z, {})
        ]
    });
};


/***/ })

}]);